<template>
  <div>
    <AdminNav />
    <div class="page">
      <h2 class="page-title">Gestion clients</h2>

      <div class="card search-card">
        <div class="filters-row">
          <input
            v-model="recherche"
            class="input"
            placeholder="Rechercher par prénom, nom, téléphone ou carte..."
            @input="charger"
          />
          <select v-model="commercantFiltre" class="input select-commercant" @change="charger">
            <option value="">Tous les commerçants</option>
            <option v-for="c in commercants" :key="c.id" :value="c.id">
              {{ c.nom_enseigne }}
            </option>
          </select>
        </div>
        <div class="stats-filtres" v-if="clients.length">
          <span>{{ clients.length }} client(s)</span>
          <span v-if="commercantFiltre">· filtré par commerçant</span>
        </div>
      </div>

      <div class="card">
        <div class="table-wrap"><table class="table">
          <thead>
            <tr>
              <th>Client</th>
              <th>Commerçant</th>
              <th>Carte</th>
              <th>Téléphone</th>
              <th>Marché inscription</th>
              <th>Points</th>
              <th>Transactions</th>
              <th>Inscription</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="c in clients" :key="c.id">
              <td>
                <div class="client-cell">
                  <div class="avatar">{{ c.prenom ? c.prenom[0] : '?' }}{{ c.nom ? c.nom[0] : '' }}</div>
                  <div>
                    <strong>{{ c.prenom }} {{ c.nom }}</strong>
                    <span class="badge-inactive" v-if="!c.actif">Supprimé</span>
                  </div>
                </div>
              </td>
              <td class="commercant-cell">{{ c.nom_enseigne || '—' }}</td>
              <td class="mono">{{ c.numero_carte }}</td>
              <td>{{ c.telephone || '—' }}</td>
              <td>
                <span class="badge-ville" v-if="c.marche_inscription">📍 {{ c.marche_inscription }}</span>
                <span class="no-data" v-else>—</span>
              </td>
              <td><strong class="points">{{ c.points_solde }}</strong></td>
              <td>{{ c.nb_transactions }}</td>
              <td class="date">{{ formatDate(c.date_inscription) }}</td>
              <td class="actions-cell">
                <button class="btn-action" @click="editer(c)" title="Modifier">✏️</button>
                <button class="btn-action delete" @click="supprimer(c.id)" title="Supprimer RGPD">🗑️</button>
              </td>
            </tr>
          </tbody>
        </table></div>
        <div class="vide" v-if="!clients.length && !loading">Aucun client trouvé</div>
      </div>

      <!-- Popup éditer -->
      <div class="modal-overlay" v-if="popupEditer" @click.self="popupEditer = false">
        <div class="modal">
          <h3>Modifier client</h3>
          <div class="form-row">
            <div class="form-group"><label class="label">Prénom</label><input v-model="formEdit.prenom" class="input" /></div>
            <div class="form-group"><label class="label">Nom</label><input v-model="formEdit.nom" class="input" /></div>
          </div>
          <div class="form-group"><label class="label">Téléphone</label><input v-model="formEdit.telephone" class="input" /></div>
          <div class="form-group"><label class="label">Points</label><input v-model.number="formEdit.points_solde" class="input" type="number" /></div>
          <div class="modal-actions">
            <button class="btn btn-secondary" @click="popupEditer = false">Annuler</button>
            <button class="btn btn-primary" @click="sauvegarder">Sauvegarder</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import AdminNav from '../../components/AdminNav.vue'
import adminApi from '../../adminApi'

export default {
  name: 'AdminClients',
  components: { AdminNav },
  data() {
    return {
      clients:          [],
      commercants:      [],
      commercantFiltre: '',
      recherche:        '',
      loading:          false,
      popupEditer:      false,
      formEdit:         { id: '', prenom: '', nom: '', telephone: '', points_solde: 0 },
      timer:            null
    }
  },
  methods: {
    formatDate(d) { return new Date(d).toLocaleDateString('fr-FR') },

    async chargerCommercants() {
      try {
        const res        = await adminApi.get('/commercants')
        this.commercants = res.data
      } catch {}
    },

    async charger() {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        this.loading = true
        try {
          const params = new URLSearchParams()
          if (this.recherche)        params.set('q', this.recherche)
          if (this.commercantFiltre) params.set('commercant_id', this.commercantFiltre)
          const res    = await adminApi.get(`/clients?${params.toString()}`)
          this.clients = res.data
        } catch {} finally {
          this.loading = false
        }
      }, 300)
    },

    editer(c) {
      this.formEdit = { id: c.id, prenom: c.prenom, nom: c.nom, telephone: c.telephone, points_solde: c.points_solde }
      this.popupEditer = true
    },

    async sauvegarder() {
      try {
        await adminApi.put(`/clients/${this.formEdit.id}`, this.formEdit)
        this.popupEditer = false
        await this.charger()
      } catch {}
    },

    async supprimer(id) {
      if (!confirm('Supprimer ce client (RGPD) ? Cette action est irréversible.')) return
      try { await adminApi.delete(`/clients/${id}`); await this.charger() } catch {}
    }
  },
  mounted() {
    this.chargerCommercants()
    this.charger()
  }
}
</script>

<style scoped>
.page { width: 100%; max-width: 1280px; margin: 0 auto; padding: 24px; box-sizing: border-box; }
.page-title { font-size: 22px; font-weight: 700; margin-bottom: 20px; }

.search-card { background: white; border-radius: 14px; padding: 16px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); margin-bottom: 16px; }
.filters-row { display: flex; gap: 12px; flex-wrap: wrap; }
.filters-row .input { flex: 1; min-width: 200px; }
.select-commercant { min-width: 220px; flex: 0.5; }
.stats-filtres { margin-top: 10px; font-size: 13px; color: #718096; }

.card { background: white; border-radius: 14px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.input { width: 100%; padding: 10px 14px; border: 1.5px solid #e2e8f0; border-radius: 10px; font-size: 14px; outline: none; box-sizing: border-box; }
.input:focus { border-color: #2d3748; }

.table-wrap { overflow-x: auto; -webkit-overflow-scrolling: touch; }
.table { width: 100%; border-collapse: collapse; font-size: 14px; min-width: 700px; }
.table th { text-align: left; padding: 10px 12px; font-size: 12px; color: #718096; border-bottom: 2px solid #e2e8f0; white-space: nowrap; }
.table td { padding: 10px 12px; border-bottom: 1px solid #f0f0f0; vertical-align: middle; }
.table tr:hover td { background: #f7fafc; }

.client-cell { display: flex; align-items: center; gap: 10px; }
.avatar { width: 34px; height: 34px; border-radius: 50%; background: #2d3748; color: white; font-size: 12px; font-weight: 700; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.commercant-cell { font-size: 13px; color: #4a5568; font-weight: 500; }
.mono { font-family: monospace; font-size: 12px; color: #718096; }
.points { color: #2d6a4f; font-size: 16px; }
.date { font-size: 12px; color: #a0aec0; white-space: nowrap; }
.badge-inactive { margin-left: 6px; padding: 2px 8px; border-radius: 10px; background: #fed7d7; color: #742a2a; font-size: 11px; }
.badge-ville { padding: 3px 10px; background: #ebf8ff; color: #2b6cb0; border-radius: 20px; font-size: 11px; font-weight: 600; white-space: nowrap; }
.no-data { color: #cbd5e0; }
.actions-cell { display: flex; gap: 6px; }
.btn-action { background: none; border: 1.5px solid #e2e8f0; border-radius: 8px; padding: 5px 9px; cursor: pointer; font-size: 13px; }
.btn-action:hover { background: #f7fafc; }
.btn-action.delete:hover { background: #fff5f5; border-color: #fc8181; }
.vide { text-align: center; padding: 40px; color: #718096; }

.modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 200; padding: 20px; }
.modal { background: white; border-radius: 16px; padding: 28px; max-width: 440px; width: 100%; }
.modal h3 { font-size: 18px; font-weight: 700; margin-bottom: 16px; }
.form-row { display: flex; gap: 12px; }
.form-group { flex: 1; margin-bottom: 14px; }
.label { display: block; font-size: 13px; font-weight: 600; color: #4a5568; margin-bottom: 5px; }
.modal-actions { display: flex; gap: 10px; margin-top: 16px; }
.btn { padding: 10px 20px; border-radius: 10px; border: none; font-size: 14px; font-weight: 600; cursor: pointer; flex: 1; }
.btn-primary { background: #2d3748; color: white; }
.btn-secondary { background: #edf2f7; color: #4a5568; }
@media (max-width: 600px) { .page { padding: 16px; } }
</style>
